/* eslint-disable */
import cx from 'classnames';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import { usd, newOrder, isLoggedIn, ss, navTo, mapDispatch, distance, upperFirst, setToken } from '../utils/util';
import './ManageRoom.css';
import Wrapper from './Wrapper';
import RoomForm from './partials/RoomForm';
import { SITE_DOMAIN } from '../config';

import {
  fetchUser,
  createRoom,
  listCompanies,
} from '../actions';


class AddRoom extends OzComponent {

  static need = [
    ['user', fetchUser],
  ];

  state = {};

  addRoom(e, values) {
    console.log('add room', values);
    let user = this.props.user;
    this.props.createRoom(values)
      .then(resp => {
        console.log('create room resp', resp);
        if (resp.error) {
          return;
        }
        this.props.listCompanies({ mine: 1 })
          .then(() => {
            setTimeout(() => {
              navTo('/pro/rooms');
              NotificationManager.success('Added new room');
            }, 1);
          });
      });
  }

  render() {
    let title = 'Add Room';
    return (
      <Wrapper className="Room" title={title}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className="room">
          <RoomForm
            errors={this.props.errors.room}
            values={{}}
            onSubmit={(e, values) => this.addRoom(e, values)}
            buttonText="Add Room"
          />
        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    createRoom,
    listCompanies,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddRoom);



/** WEBPACK FOOTER **
 ** ./src/components/AddRoom.js
 **/